export default __webpack_public_path__ + "static/media/profile-phat.f405985a.jpg";